// import React, { useEffect } from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// const AboutKhasdarMahotsav = () => {
//   useEffect(() => {
//     // Initialize any plugins or scripts if needed
//     // For example, if there are any jQuery plugins, initialize them here
//   }, []);

//   return (
//     <div>
//       <Header />

//       <div id="wraperexpedition">
//         <div className="bgexpedition">
//           <div id="owl-slider-home" className="owl-carousel">
//             <div className="item">
//               <video autoPlay loop muted playsInline>
//                 <source src="/videos/sanskrutik_video.mp4" type="video/mp4" />
//               </video>
//               <div className="owl-slidertext"></div>
//             </div>
//             <div className="item">
//               <video autoPlay loop muted playsInline>
//                 <source src="/videos/audyogik_video.mp4" type="video/mp4" />
//               </video>
//               <div className="owl-slidertext"></div>
//             </div>
//             <div className="item">
//               <video autoPlay loop muted playsInline>
//                 <source src="/videos/krida_video.mp4" type="video/mp4" />
//               </video>
//               <div className="owl-slidertext"></div>
//             </div>
//             <div className="item">
//               <video autoPlay loop muted playsInline>
//                 <source
//                   src="/videos/jyeshtha_nagrik_video.mp4"
//                   type="video/mp4"
//                 />
//               </video>
//               <div className="owl-slidertext"></div>
//             </div>
//             <div className="item">
//               <video autoPlay loop muted playsInline>
//                 <source src="/videos/agro_vision.mp4" type="video/mp4" />
//               </video>
//               <div className="owl-slidertext"></div>
//             </div>
//           </div>
//         </div>

//         <div className="overlay-home noselect"></div>

//         <div className="contentexpedition">
//           <div className="row">
//             <div className="col-md-12">
//               <h1 className="animfadeInUpBig">खासदार महोत्सव</h1>
//               <div className="devider-center animfadeInUpBig"></div>
//               <div id="slidertext" className="animfadeInUpBig">
//                 <div className="main-text">Sanskrutik - सांस्कृतिक</div>
//                 <div className="main-text">Krida - क्रीडा</div>
//                 <div className="main-text">Audyogik - औद्योगिक</div>
//                 <div className="main-text">
//                   Jyeshtha Nagrik - ज्येष्ठ नागरिक
//                 </div>
//                 <div className="main-text">Agro Vision - अ‍ॅग्रो व्हिजन</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="nav-bottom">
//           <div id="opengal">
//             <i className="fa fa-angle-up"></i>
//             <span>experience</span>
//           </div>
//         </div>

//         <div className="bottom-option">
//           <div className="nav-bottom-close">
//             <span>close</span>
//             <i className="fa fa-angle-down"></i>
//           </div>

//           <div id="owl-gal" className="owl-carousel">
//             <div className="item">
//               <div className="port">
//                 <div className="hovereffect">
//                   <img
//                     className="gray-color"
//                     src="/images/logo/ksm_logo.png"
//                     alt="Khasdar Sanskrutik Mahotsav"
//                   />
//                   <div className="overlay">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.facebook.com/KhasdarMahotsavNagpur/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-facebook"></i>
//                       </a>
//                       <a
//                         href="https://www.youtube.com/@KhasdarMahotsavNagpur"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-youtube"></i>
//                       </a>
//                       <a
//                         href="https://www.instagram.com/khasdarmahotsavnagpur/?hl=en"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="item">
//               <div className="port">
//                 <div className="hovereffect">
//                   <img
//                     className="gray-color"
//                     src="/images/logo/kam_logo.png"
//                     alt="Khasdar Audyogik Mahotsav"
//                   />
//                   <div className="overlay">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.facebook.com/AdvantageVidarbha/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-facebook"></i>
//                       </a>
//                       <a
//                         href="https://in.linkedin.com/company/audyogik-mahotsav-2025"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-linkedin"></i>
//                       </a>
//                       <a
//                         href="https://www.youtube.com/@advantagevidarbha25"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-youtube"></i>
//                       </a>
//                       <a
//                         href="https://www.instagram.com/advantage_vidarbha/?hl=en"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="item">
//               <div className="port">
//                 <div className="hovereffect">
//                   <img
//                     className="gray-color"
//                     src="/images/logo/krida_logo.png"
//                     alt="Khasdar Krida Mahotsav"
//                   />
//                   <div className="overlay">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.facebook.com/chakdenagpur/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-facebook"></i>
//                       </a>
//                       <a
//                         href="https://www.youtube.com/watch?v=JmMp2Nf4bxU"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-youtube"></i>
//                       </a>
//                       <a
//                         href="https://www.instagram.com/khasdarkridamahotsav/?hl=en"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="item">
//               <div className="port">
//                 <div className="hovereffect">
//                   <img
//                     className="gray-color"
//                     src="/images/logo/jn_logo.png"
//                     alt="Khasdar Jyeshtha Nagrik Mahotsav"
//                   />
//                   <div className="overlay">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.facebook.com/KhasdarMahotsavNagpur/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-facebook"></i>
//                       </a>
//                       <a
//                         href="https://www.youtube.com/watch?v=Vx8Qdx0qjA0"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-youtube"></i>
//                       </a>
//                       <a
//                         href="https://www.instagram.com/ksmnagpur/?hl=en"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="item">
//               <div className="port">
//                 <div className="hovereffect">
//                   <img
//                     className="gray-color"
//                     src="/images/logo/agro_logo.png"
//                     alt="Agro Vision"
//                   />
//                   <div className="overlay">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.facebook.com/AgrovisionIndia/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-facebook"></i>
//                       </a>
//                       <a
//                         href="https://x.com/AgrovisionIndia?ref_src=twsrc%5Etfw&ref_url=http%3A%2F%2Fwww.agrovisionindia.in%2F"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-x-twitter"></i>
//                       </a>
//                       <a
//                         href="https://www.youtube.com/channel/UCLoOSwQtFAljblIgMZRIfZA"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-youtube"></i>
//                       </a>
//                       <a
//                         href="https://www.instagram.com/agrovisionindia/?hl=en"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="fa-brands fa-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="footer animfadeInRight">
//           © All rights reserved. Khasdar Mahotsav
//           <br />
//           Developed By{" "}
//           <a
//             href="https://www.bharat-online.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: "inherit", textDecoration: "none" }}
//           >
//             Bharat Online
//           </a>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default AboutKhasdarMahotsav;


import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const contentData = [
  { type: "Sanskrutik", marathi: "सांस्कृतिक", video: "/videos/sanskrutik_video.mp4" },
  { type: "Audyogik", marathi: "औद्योगिक", video: "/videos/audyogik_video.mp4" },
  { type: "Krida", marathi: "क्रीडा", video: "/videos/krida_video.mp4" },
  { type: "Jyeshtha Nagrik", marathi: "ज्येष्ठ नागरिक", video: "/videos/jyeshtha_nagrik_video.mp4" },
  { type: "Agro Vision", marathi: "अ‍ॅग्रो व्हिजन", video: "/videos/agro_vision.mp4" },
];

const AboutKhasdarMahotsav = () => {
  // State for Video and Text Cycling (Replaces Owl Carousel)
  const [videoIndex, setVideoIndex] = useState(0);

  // State for Gallery Toggle (Replaces jQuery show/hide logic)
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  // FIX 1: Implement Video/Text Cycling using useEffect
  useEffect(() => {
    // Cycles the videoIndex every 5 seconds (5000ms)
    const intervalId = setInterval(() => {
      setVideoIndex(prevIndex => (prevIndex + 1) % contentData.length);
    }, 5000); 

    return () => clearInterval(intervalId); // Clean up the interval on unmount
  }, []);

  // FIX 2: Implement Gallery Toggle
  const toggleGallery = useCallback(() => {
    setIsGalleryOpen(prev => !prev);
  }, []);
  
  // The original useEffect is kept but now serves as a placeholder as the logic is handled by state/intervals
  // useEffect is also no longer necessary here as the logic is contained above
  
  return (
    // CRITICAL: Added the unique wrapper class for CSS scoping
    <div className="about-khasdar-mahotsav-page">
      <Header />

      <div id="wraperexpedition">
        {/* Gallery Blur Effect controlled by state */}
        <div className={`bgexpedition ${isGalleryOpen ? 'blur-content' : ''}`}>
          <div id="owl-slider-home" className="video-slider-container">
            {/* Dynamically render videos based on contentData */}
            {contentData.map((item, index) => (
              <div 
                className={`item ${index === videoIndex ? 'active' : ''}`} 
                key={item.type} // Use type for key for better identification
              >
                {/* CRITICAL FIX: Setting the key={index} on the video component forces 
                    it to re-mount and autoPlay correctly when the index changes. */}
                <video autoPlay loop muted playsInline key={index}>
                  <source src={item.video} type="video/mp4" />
                </video>
                <div className="owl-slidertext"></div>
              </div>
            ))}
          </div>
        </div>

        <div className={`overlay-home noselect ${isGalleryOpen ? 'gallery-open' : ''}`}></div>

        <div className={`contentexpedition ${isGalleryOpen ? 'minimize' : ''}`}>
          <div className="row">
            <div className="col-md-12">
              <h1 className="animfadeInUpBig">खासदार महोत्सव</h1>
              <div className="devider-center animfadeInUpBig"></div>
              
              {/* Dynamically render text based on contentData */}
              <div id="slidertext" className="animfadeInUpBig">
                {contentData.map((item, index) => (
                  <div 
                    className={`main-text ${index === videoIndex ? 'active' : ''}`} 
                    key={item.type}
                  >
                    {item.type} - {item.marathi}
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>

        {/* FIX 2: Gallery Open Button - Uses native React onClick */}
        <div className="nav-bottom" onClick={toggleGallery} role="button" aria-expanded={isGalleryOpen}>
          <div id="opengal">
            <i className="fa fa-angle-up"></i>
            <span>experience</span>
          </div>
        </div>

        {/* FIX 2: Gallery Content - Visibility controlled by isGalleryOpen state */}
        <div className={`bottom-option ${isGalleryOpen ? 'active' : ''}`}>
          <div className="nav-bottom-close" onClick={toggleGallery} role="button" aria-label="Close Gallery">
            <span>close</span>
            <i className="fa fa-angle-down"></i>
          </div>

          <div id="owl-gal" className="owl-carousel">
            {/* Note: I'm leaving the gallery content structure untouched for your CSS */}
            <div className="item">
              <div className="port">
                <div className="hovereffect">
                  <img
                    className="gray-color"
                    src="/images/logo/ksm_logo.png"
                    alt="Khasdar Sanskrutik Mahotsav"
                  />
                  <div className="overlay">
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/KhasdarMahotsavNagpur/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/@KhasdarMahotsavNagpur"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/khasdarmahotsavnagpur/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="port">
                <div className="hovereffect">
                  <img
                    className="gray-color"
                    src="/images/logo/kam_logo.png"
                    alt="Khasdar Audyogik Mahotsav"
                  />
                  <div className="overlay">
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/AdvantageVidarbha/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://in.linkedin.com/company/audyogik-mahotsav-2025"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/@advantagevidarbha25"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/advantage_vidarbha/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="port">
                <div className="hovereffect">
                  <img
                    className="gray-color"
                    src="/images/logo/krida_logo.png"
                    alt="Khasdar Krida Mahotsav"
                  />
                  <div className="overlay">
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/chakdenagpur/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/watch?v=JmMp2Nf4bxU"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/khasdarkridamahotsav/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="port">
                <div className="hovereffect">
                  <img
                    className="gray-color"
                    src="/images/logo/jn_logo.png"
                    alt="Khasdar Jyeshtha Nagrik Mahotsav"
                  />
                  <div className="overlay">
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/KhasdarMahotsavNagpur/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/watch?v=Vx8Qdx0qjA0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/ksmnagpur/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="port">
                <div className="hovereffect">
                  <img
                    className="gray-color"
                    src="/images/logo/agro_logo.png"
                    alt="Agro Vision"
                  />
                  <div className="overlay">
                    <div className="social-icons">
                      <a
                        href="https://www.facebook.com/AgrovisionIndia/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                      <a
                        href="https://x.com/AgrovisionIndia?ref_src=twsrc%5Etfw&ref_url=http%3A%2F%2Fwww.agrovisionindia.in%2F"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/channel/UCLoOSwQtFAljblIgMZRIfZA"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/agrovisionindia/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer animfadeInRight">
          © All rights reserved. Khasdar Mahotsav
          <br />
          Developed By{" "}
          <a
            href="https://www.bharat-online.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            Bharat Online
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutKhasdarMahotsav;